//ointerfaces
import { IBasicButton } from "@/interfaces/buttons";

import "../../../../../css/global/buttons/BasicButton.scss";

const BasicButton = ({ content, className, isClassicCMSBlue = false, isDisabled = false, ariaLabel, onButtonClick, isLink, linkUrl}: IBasicButton) => {

    if (isLink) {
        return (
            <a
            className={`basic-button ${isClassicCMSBlue && 'classic-style-button'} ${className} ${isDisabled && "disabled-style-link"}`}
            aria-label={ariaLabel}
            href={linkUrl}
        >
            {content}
        </a>
        )
    }
    return (
        <button
            className={`basic-button ${isClassicCMSBlue && 'classic-style-button'} ${className}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
        >
            {content}
        </button>
    );
};

export default BasicButton